import { makeStyles, fade } from '@material-ui/core/styles'
import { isDarkColor } from '@v4/utils'

const useStyles = makeStyles(
	({ palette, spacing }) => ({
		root: {
			padding: spacing(1.25),
		},
		button: {
			boxShadow: 'none',
			width: '100%',
			padding: 0,
			borderRadius: 5,
			backgroundColor: palette.background.default,
			border: `1px solid ${palette.common.imageBorder}`,
			position: 'relative',

			'&:hover, &:focus': {
				'& $dragButton, $galleryButton, $deleteButton': {
					opacity: 1,
				},
				borderColor: ({ invertColors }) => (invertColors ? palette.common.white : palette.primary.dark),
				color: ({ invertColors }) => (invertColors ? palette.common.white : null),
				cursor: 'pointer',
			},
			'&:focus': {
				boxShadow: `0 0 0 2px ${
					isDarkColor(palette.primary.dark) ? palette.primary.light : palette.primary.dark
				}`,
			},

			'&:before': {
				content: '""',
				position: 'absolute',
				backgroundColor: 'transparent',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
			},

			'&:hover:before, &:focus:before': {
				backgroundColor: fade(palette.primary.main, 0.05),
			},
		},
		checked: {
			border: `1px solid ${palette.primary.main}`,
		},
		labelWrapper: {
			display: 'flex',
			flexDirection: 'column',
		},
		dragButton: {
			width: spacing(3.25),
			height: spacing(3.25),
			borderRadius: 7,
			border: `1px solid ${palette.scoreapp.border}`,
			backgroundColor: ({ invertColors }) => (invertColors ? palette.common.white : palette.background.default),
			zIndex: 10,
			cursor: 'grab',
			color: palette.common.imageIcon,
			position: 'absolute',
			top: 5,
			left: 5,
			opacity: 0,
			transition: 'opacity 0.15s ease',

			'&:hover': {
				backgroundColor: ({ invertColors }) =>
					invertColors ? palette.common.white : palette.background.default,
				border: ({ invertColors }) => {
					const color = invertColors
						? palette.scoreapp.dark
						: palette.calcContrastColor(palette.scoreapp.primary, palette.background.default)

					return `1px solid ${color}`
				},

				'& svg': {
					color: ({ invertColors }) => {
						if (invertColors) return palette.scoreapp.dark

						return palette.calcContrastColor(palette.scoreapp.primary, palette.background.default)
					},
				},
			},

			'& svg': {
				color: palette.common.imageIcon,
			},
		},
		actionIcons: {
			position: 'absolute',
			top: 5,
			right: 5,
		},
		actionButton: {
			width: spacing(3.25),
			height: spacing(3.25),
			borderRadius: 7,
			border: `1px solid ${palette.scoreapp.border}`,
			backgroundColor: ({ invertColors }) => (invertColors ? palette.common.white : palette.background.default),
			zIndex: 10,

			'&:hover': {
				backgroundColor: ({ invertColors }) =>
					invertColors ? palette.common.white : palette.background.default,
			},
		},
		galleryButton: {
			marginRight: spacing(0.4),
			opacity: 0,
			transition: 'opacity 0.15s ease',
			color: ({ invertColors }) => {
				if (invertColors) return palette.scoreapp.dark

				return palette.calcContrastColor(palette.scoreapp.primary, palette.background.default)
			},

			'&:hover': {
				borderColor: ({ invertColors }) => {
					if (invertColors) return palette.scoreapp.dark

					return palette.calcContrastColor(palette.scoreapp.primary, palette.background.default)
				},

				'& $galleryIcon': {
					color: 'inherit',
				},
			},
		},
		galleryIcon: {
			color: palette.common.imageIcon,
		},

		deleteButton: {
			opacity: 0,
			transition: 'opacity 0.15s ease',

			'&:hover': {
				borderColor: palette.scoreapp.secondary,

				'& $deleteIcon': {
					color: palette.scoreapp.secondary,
				},
			},
		},

		deleteIcon: {
			color: palette.common.imageIcon,
		},
		media: {
			width: '100%',
			padding: spacing(1.25),
		},
		mediaContainer: {
			position: 'relative',
			width: '100%',
			paddingTop: '67.7%',
		},
		imageWrap: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
		},
		progress: {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			margin: 'auto',
		},
		image: {
			width: '100%',
			height: '100%',
			objectFit: ({ imageFit }) => imageFit || 'cover',
			borderRadius: 3,
		},
		polaroidIcon: {
			fontSize: spacing(5.9),
			color: palette.scoreapp.borderLight,
		},
		checkBox: {
			position: 'absolute',
			zIndex: 11,
			bottom: spacing(0.9),
			right: spacing(0.9),
			backgroundColor: palette.background.default,
			borderRadius: 2,
			fontSize: spacing(2.5),
			color: palette.primary.main,
		},
		content: {
			backgroundColor: 'transparent',
			paddingTop: 0,
			display: 'flex',
			width: '100%',
			padding: spacing(0, 1.25, 1.3, 1.25),
		},
	}),
	{ name: 'Questions-Image-OptionItem' },
)

export default useStyles
